/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrSymptom, PhrSymptomFromJSON, PhrSymptomFromJSONTyped, PhrSymptomToJSON } from "./";

export const PhrSymptomsTypename = "PhrSymptoms" as const;

/**
 *
 * @export
 * @interface PhrSymptoms
 */
export interface PhrSymptoms {
  /**
   *
   * @type {PhrSymptom}
   * @memberof PhrSymptoms
   */
  objective?: PhrSymptom;
  /**
   *
   * @type {PhrSymptom}
   * @memberof PhrSymptoms
   */
  subjective?: PhrSymptom;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrSymptoms
   */
  readonly __typename?: string;
}

export function PhrSymptomsFromJSON(json: any): PhrSymptoms {
  return PhrSymptomsFromJSONTyped(json, false);
}

export function PhrSymptomsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrSymptoms {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrSymptomsTypename,

    objective: !exists(json, "objective") ? undefined : PhrSymptomFromJSON(json["objective"]),
    subjective: !exists(json, "subjective") ? undefined : PhrSymptomFromJSON(json["subjective"]),
  };
}

export function PhrSymptomsToJSON(object?: PhrSymptoms | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    objective: PhrSymptomToJSON(value.objective),
    subjective: PhrSymptomToJSON(value.subjective),
  };
}
